module.exports = __webpack_public_path__ + "img/download-tile-bg-mobile_en.b8144e3.jpg";